import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { currentDateFormat } from "../utils";
import SaveButton from "../components/buttons/SaveButton";
import CancelButton from "../components/buttons/CancelButton";
import { DevTool } from "@hookform/devtools";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../messageBox/customSweetAlert";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import Loader from "../components/loader/Loader";
import { CREATE_PAYER } from "../constant";
const Payer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate, setCurrentDate] = useState(new Date());
  const { register, handleSubmit, control, formState, getValues, reset } =
    useForm();
  let { errors } = formState;
  const onSubmit = async (data) => {
    console.log("error data:", errors);
    //return false;
    try {
      dispatch(setLoading(true));
      const response = await axios.post(CREATE_PAYER, data);
      console.log("response:", response);
      if (response.data.status === "200") {
        dispatch(setLoading(false));
        navigate("list");
        Swal.fire({
          title: "Success!",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        console.log("response:", response);
        dispatch(setLoading(false));
        Swal.fire({
          title: "Error!",
          text: response.data.message,
          icon: "Error",
          confirmButtonText: "OK",
        });
      }
      //console.log('response:', response);
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error logging in:", error);
    }
  };
  return (
    <>
      <div
        className="tab-pane fade active show"
        id="add-passenger"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <section>
          <div className="d-flex justify-content-between form-container">
            <div>
              <h2 className="fs-5 font-weight-600"> Add Payor</h2>
            </div>
            <div>
              <span>{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <section>
          <div className="bg-white  px-5 py-4">
            <div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridGap: "16px",
                  }}
                >
                  <div>
                    <label className="require-field">Payor Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="payer_name"
                      {...register("payer_name", {
                        required: {
                          value: true,
                          message: "Payer Name is required",
                        },
                      })}
                    />
                    <p className="errors">
                      {errors && errors.payer_name?.message}
                    </p>
                  </div>
                  <div style={{ padding: "28px" }}>
                    <label>&nbsp;</label>
                    <SaveButton type="submit" buttonTitle={"ADD PAYOR"} />
                    <CancelButton cancelHandler={() => reset()} />
                  </div>
                </div>

                {/* <div className='footer-content'>
                            <SaveButton type='submit' buttonTitle={'ADD PAYER'} />
                            <CancelButton cancelHandler={() => reset()} />
                        </div> */}
              </form>
              <DevTool control={control} />
            </div>
          </div>
        </section>
      </div>
      <div> {loading && <Loader />}</div>
    </>
  );
};

export default Payer;
